// @mui
import { Box, Pagination, Stack, Typography } from '@mui/material';
import { m } from "framer-motion";
import { useRouter } from 'next/router';
import { ArticleProps } from 'src/@types/article';
import Routes from 'src/routes';
import BlogPostItem from './BlogPostItem';

// ----------------------------------------------------------------------

type Props = {
  articles: ArticleProps[];
};

export default function BlogPostList({ articles }: Props) {
  const router = useRouter();
  const postCount = articles.length;
  const postsPerPageCount = 8;
  const pageCount = Math.ceil(postCount / postsPerPageCount);
  const pageNumber = parseInt(router.query.page as string) || 1;

  const handleChange = (event: any, value?: number) => {
    const options = { scroll: true, shallow: true };

    if (value === undefined) {
      router.push({ pathname: Routes.blog }, undefined, { ...options });
    } else {
      router.push({ pathname: Routes.blog, query: { ...router.query, page: value } }, undefined, { ...options });
    }
  };

  return (
    <>
      <Typography variant="h3" sx={{ mb: 4 }}>{router.query.category ? "Artikler - " + router.query.category : "Alle artikler"}</Typography>
      {articles.length == 0 && (
        <Box width={1} display="flex" justifyContent="center">
          <Stack alignItems="center" sx={{ maxWidth: 480 }}>
            <Typography sx={{ color: 'text.secondary' }}>
              Beklager, her var det ingen artikler!
            </Typography>
          </Stack>
        </Box>
      )}
      <Box
        component={m.div}
        sx={{
          display: 'grid',
          rowGap: { xs: 4, md: 5 },
          columnGap: 4,
          gridTemplateColumns: {
            xs: 'repeat(1, 1fr)',
            sm: 'repeat(2, 1fr)',
          },
        }}
      >
        {articles.slice((pageNumber - 1) * postsPerPageCount, pageNumber * postsPerPageCount).map((article) => (
          <BlogPostItem key={article.slug.current} article={article} />
        ))}
      </Box>
      <Pagination
        page={pageNumber}
        onChange={handleChange}
        count={pageCount}
        color="primary"
        size="large"
        sx={{
          py: { xs: 8, md: 10 },
          '& .MuiPagination-ul': {
            justifyContent: 'center',
          },
        }}
      />
    </>
  );
}
